import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`flex items-center gap-3 font-mono text-xs font-medium uppercase tracking-[0.28em] ${
      light ? "text-[#D4A359]" : "text-[#C85A32]"
    }`}
  >
    <span className={`h-px w-8 ${light ? "bg-[#D4A359]" : "bg-[#C85A32]"}`} />
    {children}
  </p>
);
